import React, { useState, useEffect } from "react";
import { Register as RegisterContainer } from "../containers";
import firebase from "../lib/fire";
import { useHistory, useLocation } from "react-router";
import secureLocalStorage from "react-secure-storage";

export default function Register() {
  const [user, setUser] = useState("");
  const [name, setName] = useState(null);
  const [typeOfUser, setTypeOfUser] = useState(null);
  const [email, setEmail] = useState(null);
  const [password, setPassword] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const history = useHistory();
  const location = useLocation();
  const from = location.state?.from || "/app/main";

  const handleRegister = () => {
    firebase
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then((userCredential) => {
        var user = userCredential.user;
        setUser(user);
        setUpUserDataBase(user);
      })
      .catch((error) => {
        var errorMessage = error.message;
        setErrorMessage(errorMessage);
      });
  };

  const clearInputs = () => {
    setEmail("");
    setPassword("");
  };
  const authListener = () => {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        sessionStorage.setItem("userAuth", true);
        try {
          const data = firebase
            .database()
            .ref("/users/0/" + user.uid)
            .once("value")
            .then((snapshot) => {
              var username = snapshot.val() || "Anonymous";
              secureLocalStorage.setItem("userId", user.uid);
              secureLocalStorage.setItem("user", username);
            })
            .then((snapshot) => {
              clearInputs();
              if (location.state !== undefined) {
                history.replace(from.state);
              } else {
                history.push(
                  {
                    pathname: "/app/main",
                    query: {
                      fuid: user.uid,
                    },
                  },
                  "/"
                );
              }
            });
        } catch (error) {
          console.error("este es mi error", error);
        }
      }
    });
  };

  useEffect(() => {
    authListener();
  }, []);

  const setUpUserDataBase = (user) => {
    var ref = firebase
      .database()
      .ref(`users/0/${user.uid}`)
      .set({
        //crea la posicion del usuario en la base de datos
        name: name,
        mail: email,
        plan: "Basic",
        typeOfUser: typeOfUser,
        plays: [{}],
        teamId: "null",
      });
  };

  return (
    <RegisterContainer
      handleRegister={handleRegister}
      email={email}
      setEmail={setEmail}
      password={password}
      setPassword={setPassword}
      errorMessage={errorMessage}
      name={name}
      setName={setName}
      typeOfUser={typeOfUser}
      setTypeOfUser={setTypeOfUser}
    />
  );
}
